import { AI_TOOL_CATALOG } from '@/config/aiToolCatalog.js'

function cloneValue(value) {
  return value == null ? value : JSON.parse(JSON.stringify(value))
}

export function getSharedToolCatalog() {
  return Array.isArray(AI_TOOL_CATALOG) ? AI_TOOL_CATALOG.map((tool) => cloneValue(tool)) : []
}

export function getSharedTool(name) {
  const needle = String(name || '').trim()
  if (!needle) return null
  return (
    getSharedToolCatalog().find(
      (tool) =>
        tool?.name === needle ||
        (Array.isArray(tool?.aliases) && tool.aliases.some((alias) => alias === needle))
    ) || null
  )
}

export function getSharedToolNamesByExecution(execution) {
  return getSharedToolCatalog()
    .filter((tool) => tool?.execution === execution)
    .map((tool) => tool.name)
}

export function getSharedToolRegistration(name) {
  const tool = getSharedTool(name)
  if (!tool) {
    throw new Error(`Unknown shared AI tool: ${String(name || '')}`)
  }
  return {
    name: tool.name,
    description: tool.description || '',
    schema: cloneValue(tool.parameters || { type: 'object', properties: {}, required: [] }),
    kind: tool.kind || 'read',
    aliases: Array.isArray(tool.aliases) ? [...tool.aliases] : [],
    activePlanner: tool.activePlanner !== false,
    deprecated: tool.deprecated === true,
    replacement: tool.replacement || null
  }
}

export const SHARED_TOOL_CATALOG = AI_TOOL_CATALOG
